export default {"src":"/_next/static/media/logo-lgcns.408b6e50.svg","height":120,"width":182,"blurWidth":0,"blurHeight":0};